module.exports = __webpack_public_path__ + "static/media/logoMabra.b76bbef2.png";